import Application from "./application"
import Overlay from "./overlay"

if (__DEV__) {
	console.log("DEVELOPMENT ENVIRONMENT")
}
if (__SRC__) {
	console.log("SOURCE ENVIRONMENT")
}
if (__DIST__) {
	console.log("DISTRIBUTION ENVIRONMENT")
}

window.ironSelector = new Application()

// /**
//  * IFRAME RESIZING
//  */
function resizeFrame() {
	requestAnimationFrame(function () {
		// let height = 770;
		let height = window.ironSelector.getHeight()

		window.parent.postMessage(["frameHeight", height], "*")
	})
}
window.resizeFrame = resizeFrame
resizeFrame()
window.addEventListener("load", resizeFrame)
window.addEventListener("resize", resizeFrame)

window.showResultsError = function () {
	let overlay = new Overlay()
	overlay.showResultsError()
}
window.showResultsSuccess = function () {
	let overlay = new Overlay()
	overlay.showResultsSuccess()
}

/***
 *
 * TODO: If logged in to Team Titleist call this function to prepopulate the email field:
 * window.setInitialEmailValue('tom@sample.com');
 *
 */
window.setInitialEmailValue = function (email) {
	console.log("window.setInitialEmailValue: " + email)
	let overlay = new Overlay()
	overlay.setInitialEmailValue(email)
}
// window.setInitialEmailValue('tom@sample.com');

/***
 *
 * TODO: Titleist needs to write the ajax call here. Fake sample timer shows results options.
 * I think that you could move this function outside of this file if that helps.
 * Valid ids: t100, t150, t200, t350, 620mb, 620cb
 *
 */
window.submitResultsForm = function (email, primaryId, alternateId, primaryFIid, alternateFIid) {
	console.log("window.submitResultsForm: " + email + " primaryId: " + primaryId + ", alternateId: " + alternateId)
	//Put ajax calls here using parameter variable?
	//debugger;
	var xmlhttp = new XMLHttpRequest() // new HttpRequest instance
	xmlhttp.onreadystatechange = function () {
		if (xmlhttp.readyState == 4) {
			if (xmlhttp.responseText != undefined) {
				let responseM = JSON.parse(xmlhttp.responseText)
				if (responseM.Message == "Success") window.showResultsSuccess()
				else window.showResultsError()
			} else {
				window.showResultsError()
			}
		}
	}
	//debugger;
	xmlhttp.open("POST", resutlsHook);
	var formData = new FormData()
	let terms = document.querySelectorAll("#terms")
	let optin = false

	if (terms && terms[0].checked) {
		optin = true
	}
	formData.append("email", email)
	formData.append("products", primaryId)
	formData.append("products", alternateId)
	formData.append("productids", primaryFIid)
	formData.append("productids", alternateFIid)
	formData.append("source", "Iron Selector")
	formData.append("optin", optin)
	//var jsondata = JSON.stringify({email: email, products : [primaryId, alternateId], source: "Iron Selector"});
	xmlhttp.send(formData)
	// fake timer here and sample for success and error results.
	//setTimeout( function () {
	// just showing error if you use this email address for testing
	//if (email.toLowerCase() === 'error@error.com') {
	//if error
	//window.showResultsError();
	//} else {
	//if success
	//window.showResultsSuccess();
	//}

	//}, 1200);
}
